import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _createReducer;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { FETCH_UPDATE_DATE_REQUEST, FETCH_UPDATE_DATE_SUCCESS, FETCH_UPDATE_DATE_FAILURE } from 'actionTypes';
import createReducer from './createReducer';
var initialState = {
  isFetching: false,
  isRequestFailed: false,
  isLoaded: false
};
var updatedDate = createReducer(initialState, (_createReducer = {}, _defineProperty(_createReducer, FETCH_UPDATE_DATE_REQUEST, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isFetching: true,
    isRequestFailed: false,
    isLoaded: false
  });
}), _defineProperty(_createReducer, FETCH_UPDATE_DATE_SUCCESS, function (state, action) {
  return _objectSpread(_objectSpread(_objectSpread({}, state), action.payload), {}, {
    isFetching: false,
    isLoaded: true
  });
}), _defineProperty(_createReducer, FETCH_UPDATE_DATE_FAILURE, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isFetching: false,
    isRequestFailed: true
  });
}), _createReducer));
export default updatedDate;